import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const MainSection = () => {
  return (
    <>
      <div
        style={{
          backgroundImage: " url(../images/HomeBackgroudImage.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div
           className="mainSectionContainer"
          style={{
            height: "920px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            margin:"0px 80px"
            
          }}
        >
          <Row
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Col md={5}>
              <div
              className="mainSectionImage"
                style={{
                  // position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  marginTop: "150px",
                }}
              >
                <img
                className="mainImageOne"
                  src="../images/iPhoneX.png"
                  style={{ height: "500px" }}
                ></img>
              </div>
              <div
              className="mainSectionImageDivTwo"
                style={{
                  position: "relative",
                  top: "-125px",
                  left: "135px",
                }}
              >
                <img  className="mainImageTwo" src="../images/MaskLandscap.png"></img>
              </div>
            </Col>
            <Col className="mainSectionCol"  md={7}>
             <div>
             <div
                 className="mainSectionTextOne"
                style={{
                  fontSize: "60px",
                  color: "white",
                  marginTop: "0px",
                  lineHeight:"1"
                }}
              >
                {" "}
                <div
                className="mainSectionSpan"
                  style={{
                    fontStyle: "italic",
                    marginRight: "20px",
                    fontFamily: "Didot",
                  }}
                >
                  Exclusive
                </div>
             <div >    experiences</div>
              </div>
              <div
                   className="mainSectionTextTwo"
                style={{
                  fontSize: "60px",
                  color: "white",
                  marginTop: "40px",
                  marginLeft: "60px",
                  lineHeight:"1",
                  textAlign:"right"
                }}
              >
                <div
                  className="mainSectionSpan"
                  style={{
                    fontStyle: "italic",
                    fontFamily: "Didot",
                    marginRight: "20px",
                  }}
                >
                 & Unforgettable
                </div>
               <div> memories.</div>
              </div>
             </div>

             <div  
             className="mainSectionTextList"
             style={{
                  color: "white",
                }}>
             <div
                style={{
                  color: "white",
                  marginTop: "20px"
                }}
              >
                BOND is the new way to experience your city in style
              </div>
              <div
                style={{
                  color: "white",
                  marginTop: "30px",
                }}
              >
              Bond subscription allows you to get access to the hand-picked menu & wine tasting sessions, beautiful rooftops, exclusive live music venues and the most romantic dates.
              </div>
              <div> All without the struggle of planning or browsing through reviews. </div>
              <div
                style={{
                  color: "white",
                  marginTop: "30px",
                }}
              >
               
BOND experiences appeal to people who appreciate high-quality, exclusivity and unrivalled insider access. Our curated experiences offer a heightened sense of service that makes you feel above the ordinary. 
              </div>
             </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default MainSection;

